import { businessProfiles, searchTypes } from "../../aml/aml.constant";
import { CreateProfileType } from "../types/createProfile.type";

export const isBusinessProfileType = (profileType: CreateProfileType): boolean =>
  businessProfiles.includes(profileType);

export const isCreateDisabledForLinkType = (
  profileType: CreateProfileType,
  searchType: string | undefined
): boolean => {
  if (!searchType || profileType === CreateProfileType.none) {
    return false;
  }

  const isIndividualSearch = searchType === searchTypes.individual;
  const isBusinessType = isBusinessProfileType(profileType);
  const isIndividualProfileType =
    profileType === CreateProfileType.individual ||
    profileType === CreateProfileType.soleTrader;

  return (
    (isIndividualSearch && isBusinessType) ||
    (!isIndividualSearch && isIndividualProfileType)
  );
};

export const getDefaultLinkTarget = (
  profileType: CreateProfileType,
  searchType: string | undefined
): "individual" | "business" => {
  if (isBusinessProfileType(profileType)) {
    return "business";
  }

  if (
    profileType === CreateProfileType.individual ||
    profileType === CreateProfileType.soleTrader
  ) {
    return "individual";
  }

  return searchType === searchTypes.individual ? "individual" : "business";
};
